import { apiClient, clean } from "./apiClient";
import type { PageRequest, PageResponse } from "@/types/api";
import type { LeadFilter, LeadSummary } from "@/types/entities";

function leadListQueryParams(filter: LeadFilter, page: PageRequest): Record<string, unknown> {
  const { enquiryType, search, ...rest } = filter;
  const params: Record<string, unknown> = { ...clean(rest), ...clean(page) };

  const trimmedSearch = search?.trim();
  const trimmedEnquiry = enquiryType?.trim();

  if (trimmedSearch && trimmedEnquiry) {
    params.search = `${trimmedSearch} ${trimmedEnquiry}`;
  } else if (trimmedSearch) {
    params.search = trimmedSearch;
  } else if (trimmedEnquiry) {
    params.enquiryType = trimmedEnquiry;
  }

  return params;
}

export const leadsService = {
  list(filter: LeadFilter, page: PageRequest): Promise<PageResponse<LeadSummary>> {
    return apiClient
      .get<PageResponse<LeadSummary>>("/leads", { params: leadListQueryParams(filter, page) })
      .then((r) => r.data);
  },
  getOne: (id: string) =>
    apiClient.get(`/leads/${id}`).then((r) => r.data),
  update: (id: string, body: unknown) =>
    apiClient.patch(`/leads/${id}`, body).then((r) => r.data),
  updateWorkflowState: (id: string, workflowState: string | null) =>
    apiClient.patch(`/leads/${id}/workflow-state`, { workflowState }).then((r) => r.data),
  retrigger: (id: string) =>
    apiClient.post(`/leads/${id}/retrigger`),
  remove: (id: string) =>
    apiClient.delete(`/leads/${id}`),
};